import { render, staticRenderFns } from "./TrabajoAdicionalHistorialModal.vue?vue&type=template&id=c74474cc"
import script from "./TrabajoAdicionalHistorialModal.vue?vue&type=script&lang=js"
export * from "./TrabajoAdicionalHistorialModal.vue?vue&type=script&lang=js"
import style0 from "./TrabajoAdicionalHistorialModal.vue?vue&type=style&index=0&id=c74474cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports